import React from 'react';
import styled from 'styled-components';
import { translate } from 'base/shared/Localization';

const Container = styled.div`
  width: 100%;
  margin-top: 32px;
`;

const PaymentTodayBox = styled.div`
  background-color: #ffd685;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
`;

const Title = styled.h3`
  font-family: 'modelica', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  color: #1f2937;
  margin: 0 0 16px 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const DepositRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DepositText = styled.span`
  font-family: 'modelica', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  color: #1f2937;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const DepositAmount = styled.span`
  font-family: 'modelica', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  font-weight: bold;
  color: #1f2937;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const BadiFeeSection = styled.div`
  margin-top: 24px;
`;

const BadiFeeTitle = styled.h3`
  font-family: 'modelica', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  color: #1f2937;
  margin: 0 0 8px 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const BadiFeeDescription = styled.p`
  font-family: 'modelica', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: #1f2937;
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const PaymentTodaySummary = ({ deposit, fee }) => {
  if (!deposit && !fee) {
    return null;
  }

  return (
    <Container>
      {deposit && (
        <PaymentTodayBox>
          <DepositRow>
            <DepositText>{translate('booking.summary.seeker_pay_deposit')}</DepositText>
            <DepositAmount>{deposit}</DepositAmount>
          </DepositRow>
        </PaymentTodayBox>
      )}

      {fee && (
        <BadiFeeSection>
          <BadiFeeTitle>{translate('booking.preview.fee_payment_label')}</BadiFeeTitle>
          <BadiFeeDescription>
            {translate('booking.preview.seeker.fee_payment_description')}
          </BadiFeeDescription>
        </BadiFeeSection>
      )}
    </Container>
  );
};

export default PaymentTodaySummary;
